import type { TaskSchedule, TaskScheduleUpsertPayload } from "../../../api/requests";

export type SchedulePeriod = "daily" | "weekly" | "monthly";

export interface ScheduleFormState {
  period: SchedulePeriod;
  weekDay: number;
  monthDay: number;
  monthLastDay: boolean;
}

export const DEFAULT_SCHEDULE_FORM: ScheduleFormState = {
  period: "daily",
  weekDay: 1,
  monthDay: 1,
  monthLastDay: false,
};

export const scheduleFormFromItem = (item: TaskSchedule | null): ScheduleFormState => {
  if (!item) return { ...DEFAULT_SCHEDULE_FORM };

  const period = item.schedule?.period ?? "daily";
  const next: ScheduleFormState = {
    period,
    weekDay: 1,
    monthDay: 1,
    monthLastDay: false,
  };

  if (period === "weekly") {
    next.weekDay = item.schedule.weekDay ?? 1;
  }

  if (period === "monthly") {
    const day = item.schedule.day ?? 1;
    if (day >= 31) {
      next.monthLastDay = true;
      next.monthDay = 1;
    } else {
      next.monthDay = Math.min(Math.max(day, 1), 31);
    }
  }

  return next;
};

export const buildSchedulePayload = (
  id: string,
  form: ScheduleFormState,
  kind: "site" | "it" = "site"
): TaskScheduleUpsertPayload => {
  const payload: TaskScheduleUpsertPayload = {
    ...(kind === "it" ? { itCheckRequestId: id } : { requestId: id }),
    schedule: { period: form.period },
  };

  if (form.period === "weekly") {
    payload.schedule.weekDay = form.weekDay;
  }

  if (form.period === "monthly") {
    payload.schedule.day = form.monthLastDay ? 32 : form.monthDay;
  }

  return payload;
};
